<template>
    <span>
        <div style="text-align: center; margin-top: 50px;">
            <btn cssClass="btn-primary btn-lg" icon="fas fa-cloud-upload-alt" :click="addFile">Upload csv</btn>
        </div>
        <input type="file" id="files" ref="files" multiple v-on:change="handleFileUpload()" style="visibility: hidden"/>
    </span>
</template>

<script>
    export default {
        props: [
            'budget_period_id'
        ],
        data() {
            return {
                files: '',
                promiseResolve: null
            };
        },
        methods: {
            addFile() {
                this.$refs.files.click();
                return new Promise((resolve, reject) => {
                    this.promiseResolve = resolve;
                });
            },
            handleFileUpload() {
                this.files = this.$refs.files.files;
                this.submitFile();
            },
            submitFile() {
                const $this = this;
                let formData = new FormData();
                for( var i = 0; i < this.files.length; i++ ) {
                    let file = this.files[i];
                    formData.append('files[' + i + ']', file);
                }
                return axios.post( url(`ajax/admin/upload-file`), formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                }).then(response => {
                    if (!response.data.files.length || response.data.files[0].extension.toLowerCase() !== 'csv') {
                        $this.$message.error(`The file is not CSV. You need to upload a CSV file to proceed to the next step.`);
                        window.location.reload();
                    } else return axios.post(url(`admin/driver-upload/upload-csv`), response.data)
                        .then((response) => {
                            this.$emit('uploadFinished', { data: response.data});
                            $this.$refs.files.value = '';
                            this.promiseResolve();
                        });
                });
            },
        },
    }
</script>

<style>
</style>
